import type {CoreExportFormat} from '@wix/document-services-types'
import type {DecorationPluginFunction} from '../../types'
import {converter as coreConverter} from '@wix/document-management-core-converter'

export const unpack: DecorationPluginFunction = (componentExport: CoreExportFormat) => {
    componentExport.version = coreConverter.getVersion()
}
